export const toNumber = (value: string) =>
  (`${value}`.match(/\d+(\.\d+)?/g) || []).join('');
